"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isUndefined_1 = __importDefault(require("lodash/isUndefined"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const cleanType_1 = __importDefault(require("./cleanType"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const getObjectNode_1 = __importDefault(require("./getObjectNode"));
const convertTypedModel_1 = require("../getValidationErrors/convertTypedModel");
const cleanObjectFields = async function ({ schema, value, ...other }) {
    const keys = Object.keys(schema.type).filter(key => !key.startsWith('__'));
    const newDoc = {};
    for (const key of keys) {
        try {
            const cleanOptions = {
                ...other,
                schema: schema.type[key],
                value: value[key],
                currentDoc: value
            };
            const newValue = await clean(cleanOptions);
            if (!(0, isUndefined_1.default)(newValue)) {
                newDoc[key] = newValue;
            }
        }
        catch (error) {
            throw new Error(`Error cleaning field ${key}, error: ${error.message}`);
        }
    }
    return newDoc;
};
const cleanArrayItems = async function ({ schema, value, ...other }) {
    // clean array items
    const schemaType = schema.type[0];
    const promises = value.map(async (item, index) => {
        const newValue = await clean({
            ...other,
            schema: {
                type: schemaType
            },
            value: item,
            currentDoc: value
        });
        return newValue;
    });
    const result = await Promise.all(promises);
    return result.filter(value => !(0, isUndefined_1.default)(value));
};
function getArrayNode(schema, value) {
    if ((0, isArray_1.default)(schema.type) && !(0, isNil_1.default)(value)) {
        const result = schema;
        return result;
    }
    return null;
}
const clean = async function (info) {
    (0, convertTypedModel_1.convertTypedModel)(info);
    let { schema, args = [], value } = info;
    const currSchema = schema.type === undefined ? { type: schema } : schema;
    const objectSchema = (0, getObjectNode_1.default)(currSchema, value);
    if (objectSchema) {
        const newDoc = await cleanObjectFields({
            ...info,
            schema: objectSchema,
            value: value
        });
        const result = await (0, cleanType_1.default)('plainObject', objectSchema, newDoc, info, ...args);
        return result;
    }
    const arraySchema = getArrayNode(currSchema, value);
    if (arraySchema) {
        let updatedValue = value;
        if (!(0, isArray_1.default)(value) && !Array.isArray(value)) {
            updatedValue = [value];
        }
        const newDoc = await cleanArrayItems({
            ...info,
            schema: arraySchema,
            value: updatedValue
        });
        const result = await (0, cleanType_1.default)('array', arraySchema, newDoc, info, ...args);
        return result;
    }
    const result = await (0, cleanType_1.default)(currSchema.type, currSchema, value, info, ...args);
    return result;
};
exports.default = clean;
